import { render, staticRenderFns } from "./aTestApp.vue?vue&type=template&id=756e6004"
import script from "./aTestApp.vue?vue&type=script&lang=js"
export * from "./aTestApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports